import styled from 'styled-components'

export const SC_DocumentsListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`

export const SC_SubcategoriesDrawerWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`